import { render, staticRenderFns } from "./tabPanelSetting.vue?vue&type=template&id=28f0cbb3&"
import script from "./tabPanelSetting.vue?vue&type=script&lang=js&"
export * from "./tabPanelSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/tabPanel/tabPanelSetting.vue"
export default component.exports